import { DotcEnums } from 'src/common/contracts/enums/dotc'
import { big, safeDiv } from 'src/common/utils/big-utils'
import { calcPercentageDifference } from 'src/common/utils/offers/offerPrices'

export const validatePricePerUnit = (
  pricePerUnit: Big,
  sellTokenPrice: number | undefined,
  buyTokenPrice: number | undefined,
  isDynamic: boolean
) => {
  const marketPrice = safeDiv(sellTokenPrice, buyTokenPrice)
  const maxPrice = marketPrice.mul(2)
  const percentageDifference =
    sellTokenPrice && calcPercentageDifference(pricePerUnit, marketPrice)

  if (!percentageDifference) {
    return {
      newPricePerUnit: pricePerUnit,
      newPercentage: 0,
      newPercentageType: null,
    }
  }

  let newPricePerUnit = pricePerUnit
  let newPercentage = percentageDifference

  if (isDynamic) {
    if (percentageDifference.gt(100)) {
      newPercentage = big(100)
      newPricePerUnit = maxPrice
    }
  }

  const newPercentageType = percentageDifference.eq(0)
    ? null
    : percentageDifference.gt(0)
    ? DotcEnums.PercentageType.Plus
    : DotcEnums.PercentageType.Minus

  return {
    newPricePerUnit,
    newPercentage: newPercentage.toNumber(),
    newPercentageType,
  }
}

export const calculatePricePerUnit = (
  sellAmount: Big,
  buyAmount: Big,
  isSwapped: boolean
): Big =>
  isSwapped ? safeDiv(sellAmount, buyAmount) : safeDiv(buyAmount, sellAmount)
